export const MuiTextFieldConfig = {
    defaultProps: {
        size: 'medium',
        variant: 'standard',
    },
};
